import React, { useEffect, useState } from 'react'
import { ChampSeriesScheduleCon } from './styles'
import { Loading } from '../../Loading'
import { EventGQL, fetchSeasonEvents } from '../../../Api'
import { EVENTS_YEAR } from '../../../Config/League/league.config'
import { SEASON_SEGMENT_NAMES } from '../../../Utils'
import { ChampSeriesEventsCon } from './components/ChampSeriesEventsCon'

const CSSchedule: React.FC<React.PropsWithChildren<unknown>> = () => {
  const [csEvents, setCSEvents] = useState<EventGQL[]>([])
  const [eventsLoading, setEventsLoading] = useState(true)

  useEffect(() => {
    fetchCSEvents()
  }, [])

  const fetchCSEvents = async () => {
    try {
      const eventsRes = await fetchSeasonEvents(EVENTS_YEAR, true)
      if (eventsRes && eventsRes.length > 0) {
        const evs = eventsRes.filter(
          (ev) => ev.seasonSegment === SEASON_SEGMENT_NAMES.champseries
        )
        setCSEvents(evs)
      }
      setEventsLoading(false)
    } catch (err) {
      console.log('Error getting events', err)
      setEventsLoading(false)
    }
  }

  if (eventsLoading) {
    return <Loading />
  }

  return (
    <>
      {csEvents.length > 0 && (
        <ChampSeriesScheduleCon>
          <ChampSeriesEventsCon events={csEvents} />
        </ChampSeriesScheduleCon>
      )}
    </>
  )
}

export default CSSchedule
